import { ActionTree, Commit } from 'vuex';
import { IRootState } from '../root-state.store';
import { IAgendaState } from './agenda-state.store';
import { AGENDA_LOADING, AGENDA_GET_APPOINTMENTS, AGENDA_SET_APPOINTMENTS, AGENDA_SET_DATE, AGENDA_GET_APPOINTMENT_BY_ID, AGENDA_RECORD, AGENDA_DELETE, AGENDA_MODIFY, AGENDA_SET_CURRENT_APPOINTMENT, AGENDA_SET_APPOINTMENT_BY_ID, AGENDA_PUSH_APPOINTMENT, AGENDA_SET_DATE_APPOINTMENT, AGENDA_GET_APPOINTMENTS_TICKET, AGENDA_ASSIGN_APPOINTMENT } from './agenda-types.store';
import { IAppointmentParameter, IAppointment, IAppointmentListingViewModel, IAppointmentQuickUpdate } from '../../models/appointment';
import { ActivityStatus } from '../../common/enums';

export const actions: ActionTree<IAgendaState, IRootState> = {
  [AGENDA_GET_APPOINTMENTS]: async ({ getters, state, commit }) => {

    commit(AGENDA_LOADING, ActivityStatus.Loading);

    return await getters.service!.getAppointments(getters.appointmentParameter)
      .then(({ originalAppointments, events }) => {
        commit(AGENDA_SET_APPOINTMENTS, {
          activityStatus: ActivityStatus.Loaded,
          appointments: originalAppointments
        });
        return events;
      })
      .catch(error => {
        commit(AGENDA_LOADING, ActivityStatus.LoadFailed);
        return Promise.reject(error)
      })
  }
  , [AGENDA_GET_APPOINTMENTS_TICKET]: async ({ getters, state, commit }, param) => {

    return await getters.service!.getAppointments(param)
      .then(response => {
        console.log(response);
        return response;
      })
      .catch(error => {
        return Promise.reject(error)
      })
  }
  , [AGENDA_GET_APPOINTMENT_BY_ID]: async ({ getters, commit }, id: string) => {
    const appointment: IAppointment = getters.appointments.find(app => app.id === parseInt(id));
    const cookedAppointment = getters.service.getAppointmentById(id, appointment);

    if (appointment) {
      commit(AGENDA_SET_APPOINTMENT_BY_ID, {
        activityStatus: ActivityStatus.Loaded,
        appointment: cookedAppointment,
        originUpdatingAppointment: appointment
      });
      return appointment
    }
    else
      return Promise.reject('Not found');
  }
  , [AGENDA_RECORD]: async ({ getters, state, commit, rootGetters }, type: string = 'confirmed') => {

    let promise: Promise<IAppointmentListingViewModel>;

    if (getters.appointment.id > 0) {
      promise = getters.service!.updateFullAppointment(getters.appointment, state.originUpdatingAppointment)
    } else {
      promise = getters.service!.recordAppointment(getters.appointment, type)
    }


    return promise
      .then(response => {

        if (rootGetters['block/blocks']) {
          const assocciatedBlock = rootGetters['block/blocks'].find(x => x.id === response['originalAppointment'].fk_block);

          if (assocciatedBlock) {
            response['appointment'].block = {
              name: assocciatedBlock.name,

            }
            response.blockName = assocciatedBlock.name
          }
        }

        commit(AGENDA_PUSH_APPOINTMENT, response)
        return Promise.resolve({
          isUpdate: getters.appointment.id > 0,
          ...response
        });
      })
      .catch(error => {
        console.log(error)
        return Promise.reject(error);
      })
  }

  , [AGENDA_MODIFY]: async ({ getters, commit }, payload: IAppointmentQuickUpdate) => {
    return await getters.service!.updateAppointment(payload)
      .then((appointmentViewmodel: IAppointmentListingViewModel) => {
        commit(AGENDA_SET_DATE_APPOINTMENT, appointmentViewmodel)
        return Promise.resolve(appointmentViewmodel);
      })
      .catch(error => {
        console.log(error)
        return Promise.reject(error);
      })
  }

  , [AGENDA_DELETE]: async ({ getters, commit }, payload: { originId: string, ticketId: string }) => {

    return await getters.service!.removeAppointment(payload)
      .then(result => {
        return Promise.resolve(result);
      })
      .catch(error => {
        console.log(error)
        return Promise.reject(error);
      })
  }
  , [AGENDA_ASSIGN_APPOINTMENT]: async ({ getters, dispatch, commit }, appointment: IAppointment) => {

    const cookedAppointment = getters.service.getAppointmentById(appointment.id, appointment);

    commit(AGENDA_SET_APPOINTMENT_BY_ID, {
      activityStatus: ActivityStatus.Loaded,
      appointment: cookedAppointment,
      originUpdatingAppointment: appointment
    });
    
  }

}


// WEBPACK FOOTER //
// ./src/store/agenda/agenda-actions.store.ts